import { NewTaskComponent } from "./new-task.component";
import { UserTasks } from "@components/user-tasks"
import { connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles';
import combineStyles from '~/utils/styles';
import form from '@style/form'
import modal from '@style/modal'

const mapStateToProps = (state, props) => ({
    context: state.context || {},
});

const actions = {
    addUserTask: UserTasks.actions.addUserTask,
    updateUserTask: UserTasks.actions.updateUserTask,
};

export const NewTaskContainer = connect(mapStateToProps, actions)(withStyles(combineStyles(form, modal))(NewTaskComponent));
